import styled from 'styled-components';
import { H3 } from 'components/typography';
import { Row } from 'components/layout';
import { ReactComponent as Arrow } from 'styles/icons/arrow.svg';
import { H2 as GenericH2 } from 'components/typography/style';
import { color, typography } from 'styles/settings';
import { normalize, withModifiers } from 'utils/styles';

export const Container = styled.div`
  background-color: ${color.neutral.white};
  max-width: 960px;
  width: 50%;
  margin-left: 25%;
  margin-top: 15%;
  padding: 15px;
  border-radius: 10px;
  @media all and (max-width: 1200px) {
    width: 80%;
    margin-left: 10%;
    margin-top: 20%;
  }
`;

export const Separator = styled.div`
  border-bottom: 1px solid ${color.neutral.grayLight};
  height: ${normalize('32px')};
  margin: 0 ${normalize('-32px')};
  margin-bottom: ${normalize('24px')};
`;

export const Text = styled.span`
  display: flex;
  flex-direction: column;
  ${typography.font.content.regular};
  font-size: ${typography.size.md};

  ${withModifiers('bold')`
    font-weight: bold;
  `}
`;

export const SubTitleContainer = styled(Row)`
  align-items: center;
  cursor: pointer;
`;

export const SubTitle = styled(H3)`
  font-size: ${typography.size.md};
  line-height: ${typography.size.lg};
`;

export const ArrowIcon = styled(Arrow)`
  color: ${color.brand.blueDark};
  cursor: pointer;
  height: ${normalize('16px')};
  width: ${normalize('16px')};
  transform: rotate(270deg);
  transition: transform 0.3s linear;
`;

export const RightArrowIcon = styled(Arrow)`
  color: ${color.brand.gold};
  cursor: pointer;
  height: ${normalize('16px')};
  width: ${normalize('16px')};
  transform: rotate(90deg);
  transition: transform 0.3s linear;
`;

export const SearchWrapper = styled.div`
  margin: 30px 45px;
  height: 80%;
`;

export const TabContainer = styled.div`
  margin-top: 50px;
  margin-bottom: 20px;
`;

export const Title = styled(GenericH2)`
  ${typography.font.title.bold};
  font-size: 46px;
  line-height: 81px;
`;
